/**
 * Thin wrapper around window.gtag for safe GA4 event tracking.
 * Silently no-ops if gtag isn't loaded (e.g. in dev or if adblocker is active).
 */
export const trackEvent = (eventName, params = {}) => {
  if (typeof window === "undefined") return;
  if (typeof window.gtag === "function") {
    try {
      window.gtag("event", eventName, params);
    } catch {
      // ignore
    }
  }
};
